export default __webpack_public_path__ + "static/media/kohut-4.07b19e50.jpg";